export default {
    showChangesDurationInSeconds:20
}